module.exports = __webpack_public_path__ + "img/connessa.ec7c8a1d.svg";